<template>
  <v-row>
    <v-col cols="12">
      <div id="qualityChart"></div>
      <v-col
        cols="12"
        align-self="center"
        class="align-center justify-center mt-n3"
        align="center"
      >
        <h2 style="color: white" v-if="qualityData">
          {{ qualityData.class }}
        </h2>
      </v-col>
    </v-col>
  </v-row>
</template>

<script>
/* eslint-disable */
import Highcharts from 'highcharts';
import Exporting from 'highcharts/modules/exporting';
import Acessibility from 'highcharts/modules/accessibility';
Acessibility(Highcharts);
Exporting(Highcharts);
export default {
  props: ['quality'],
  name: 'WaterQualityChart',
  data() {
    return {
      legend: '',
      qualityData: null,
    };
  },
  mounted() {
    this.dataSource();
  },
  methods: {
    async dataSource() {
      this.qualityData = this.quality.values.find(
        (obj) => obj.tipo === 'total',
      );
      this.chartPreprocessing();
    },
    chartPreprocessing() {
      const elementId = 'qualityChart';
      let chart = document.getElementById(elementId);
      if (this.quality) {
        this.charts(this.qualityData);
        this.loading = false;
        chart.style.visibility = 'visible';
        chart.style.display = 'block';
      } else {
        chart.style.visibility = 'hidden';
        chart.style.display = 'none';
      }
    },
    async charts(quality) {
      Highcharts.chart('qualityChart', {
        chart: {
          type: 'gauge',
          backgroundColor: this.$vuetify.theme.themes.dark.primary.darken1,
          height: 100,
        },
        title: {text: null},
        subtitle: {text: null},
        exporting: {enabled: false},
        credits: {enabled: false},
        pane: {
          center: ['50%', '85%'],
          size: '150%',
          startAngle: -90,
          endAngle: 90,
          background: null,
        },
        plotOptions: {
          gauge: {
            pivot: {
              radius: 3,
            },
            dial: {
              borderWidth: 0,
              baseWidth: 2,
            },
            dataLabels: {
              enabled: false,
            },
          },
        },
        // the value axis
        yAxis: {
          reversed: false,
          min: 0,
          max: 100,
          minorTickInterval: 'auto',
          minorTickWidth: 0,
          minorTickLength: 0,
          minorTickPosition: 'outside',
          minorTickColor: 'transparent',
          tickPixelInterval: 100,
          tickWidth: 0,
          tickPosition: 'outside',
          tickLength: 0,
          tickColor: 'transparent',
          lineWidth: 0,
          tickPositions: [0, 44, 64, 79, 100],
          tickAmount: 2,
          labels: {
            enabled: false,
            rotation: 'top',
            verticalAlign: 'top',
            y: 5,
            x: 0,
            align: 'center',
            distance: '62%',
            style: {
              color: '#FFFFFF',
            },
          },
          title: {text: null},
          subtitle: {text: null},
          plotBands: [
            {
              from: 0,
              to: 44,
              color: '#C00000',
              thickness: '26%',
            },
            {
              from: 44,
              to: 64,
              color: '#C75911',
              thickness: '26%',
            },
            {
              from: 64,
              to: 79,
              color: '#FFD966',
              thickness: '26%',
            },
            {
              from: 79,
              to: 94,
              color: '#FFAB00',
              thickness: '26%',
            },
            {
              from: 94,
              to: 100,
              color: '#8EA9DB',
              thickness: '26%',
            },
          ],
        },
        tooltip: {
          enabled: true,
        },
        series: [
          {
            name: 'Disponibilidade',
            data: [quality.valor],
            tooltip: {
              pointFormat: '<b>{point.y} %</b>',
              //valueSuffix: quality.suffix
            },
          },
        ],
        // caption:{
        //   text: 'Card Disponibilidade Hídrica',
        //   style: { color: '#FFFFFF'},
        // }
      });
    },
  },
};
</script>

<style>
.highcharts-gauge-series .highcharts-dial {
  fill: white;
}
.highcharts-gauge-series .highcharts-pivot {
  stroke: white;
  fill: white;
  stroke-width: 0;
}
</style>
